import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'

import TitleCard from '@components/Multiline/HighFive/TitleCard'
import { HighFiveProps } from '@components/Multiline/HighFive/types'

import { desktopCSS, mobileCSS, tabletCSS } from '@measures/responsive'

import highFiveStripedBackground from '@assets/images/high-five-striped-background.png'

const StyledHighFiveContainer = styled.div`
  ${({
    theme: {
      colors: {
        blicktvGrey: { btvGrey_60 },
      },
    },
  }) => css`
    display: grid;
    grid-gap: 20px;
    box-sizing: border-box;
    background: url(${highFiveStripedBackground}) no-repeat 15% 0,
      linear-gradient(269.98deg, #db021b 2.79%, ${btvGrey_60} 68.93%);
    ${desktopCSS(css`
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: repeat(2, auto);
      grid-auto-flow: row;
      width: 100%;
      padding: 20px 16px;
    `)}
    ${tabletCSS(css`
      height: 240px;
      overflow-x: scroll;
      overflow-y: hidden;
      grid-template-columns: repeat(5, 312px) 328px;
      margin: 0 -52px;
      width: calc(100% + 104px);
      padding: 20px 0;
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
      ::-webkit-scrollbar {
        display: none;
      }
    `)}
    ${mobileCSS(css`
      display: none;
    `)}
  `}
`

const DesktopTabletVersion: FunctionComponent<HighFiveProps> = ({
  formattedUpdatedDate,
  timeframe,
  children,
}) => {
  return (
    <StyledHighFiveContainer>
      <TitleCard
        formattedUpdatedDate={formattedUpdatedDate}
        timeframe={timeframe}
      />
      {children}
    </StyledHighFiveContainer>
  )
}

export default DesktopTabletVersion
